import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { EpisodesApi, ShowsApi } from '../../../network';
import { EpisodeModel, ShowModel } from '../../../network/rest';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import Pagination from '../../components/Pagination';
import './style.scss';
import ListItemWithShortDescription from '../../components/ListItemWithShortDescription';

function ShowEpisodes() {
    const [data, setData] = useState<EpisodeModel[]>([]);
    const [dataCount, setDataCount] = useState(0);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 10,
    });
    const [showData, setShowData] = useState<ShowModel | undefined>();
    const { showId } = useParams();
    const previousShowId = useRef(showId);

    async function getData() {
        try {
            if (!showId) {
                return;
            }
            const response = await EpisodesApi.getEpisodesApiV1EpisodesGet({
                showId,
                offset: controller.page * controller.rowsPerPage,
                limit: controller.rowsPerPage,
            });
            if (response) {
                setData(response.episodes);
                setDataCount(response.total);
            }
        } catch (e) {
            ApiErrorHandler(e, true);
        }
    }

    useEffect(() => {
        const isNewShow = previousShowId.current !== showId;
        previousShowId.current = showId;

        // another show invalidates the current offset, so go back to the first
        // page and let that controller change trigger the fetch
        if (isNewShow && controller.page !== 0) {
            handlePageChange(0);
            return;
        }

        getData();
    }, [controller, showId]);

    useEffect(() => {
        const getShowName = async (id: string) => {
            const response = await ShowsApi.getShowApiV1ShowsShowGet({ id });
            if (response) {
                setShowData(response);
            }
        };

        if (showId) {
            getShowName(showId);
        }
    }, [showId]);

    function handlePageChange(newPage: number) {
        setController({
            ...controller,
            page: newPage,
        });
    }

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0,
        });
    };

    return (
        <div className="ShowEpisodes">
            {showData ? <h1>{showData.title}</h1> : null}
            <div className="content-wrapper">
                {data.map((show, idx) => (
                    <ListItemWithShortDescription key={`${show.title}${idx}`} data={show} />
                ))}
            </div>
            <Pagination
                page={controller.page}
                count={dataCount}
                rowsPerPage={controller.rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    );
}

export default ShowEpisodes;
